import { useEffect, useState, useRef } from 'react';

import Participants from './Participants';
import Message from './Message';
import ActivityIndicator from './ActivityIndicator';

function Chat({ messages, participants }) {
    const [index, setIndex] = useState(0);
    const [isTyping, setIsTyping] = useState(false);
    const messageTimer = useRef();
    const typingTimer = useRef();

    useEffect(() => {
        next();

        return () => {
            stop();
        };
    }, []);

    useEffect(() => {
        if (index >= messages.length) {
            // setIndex(0);
        } else {
            typingTimer.current = setTimeout(() => {
                setIsTyping(true);
            }, 1000);
        }

        return () => {
            clearTimeout(typingTimer.current);
        };
    }, [index]);

    function next() {
        messageTimer.current = setTimeout(() => {
            setIsTyping(false);
            setIndex((_index) => _index + 1);
            next();
        }, 2000 + Math.random() * 4000);
    }

    function stop() {
        if (messageTimer.current) {
            clearTimeout(messageTimer.current);
        }
    }

    return (
        <>
            <section className="Messages">
                <Participants participants={participants}></Participants>

                {/* {messages.map((message) => ( */}

                {messages.slice(0, index).map((message, index) => (
                    <Message
                        message={message}
                        participant={participants?.[messages?.participant]}
                        key={index}
                    ></Message>
                ))}

                <ActivityIndicator isActive={isTyping} participant={messages?.[index]?.participant}></ActivityIndicator>
            </section>
        </>
    );
}

export default Chat;
